import React from 'react';
import { Dialog, Grid, IconButton, } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
// import ReactImageMagnify from 'react-image-magnify';

function ImgSingleViewer(props) {
  const {
    currentImg,
    openImgModal,
    onClose,
  } = props;  
  return (
    <Dialog fullScreen open={openImgModal} onClose={onClose}>
      <Grid item xs={1}>
        <IconButton aria-label="Close" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Grid>
      <Grid container item xs={12}>
        <Grid item xs={6}>
          <Zoom>
            <img alt="To see full report, please download the file" src={currentImg} width="100%" style={{ cursor: 'zoom-in' }} />
          </Zoom>
          {/* <ReactImageMagnify
            {...{
              smallImage: {
                alt:'To see full report, please download the file',
                isFluidWidth: true,
                src: currentImg,

              },
              largeImage: {
                src: currentImg,
                width: 1800,
                height: 1800,
              },
            }}
          /> */}
        </Grid>
        <Grid item xs={6} />
      </Grid>
    </Dialog>
  );
}


export default ImgSingleViewer;
